<template>
  <modal name="entity-modal" height="auto" width="480px" :scrollable="true" :shiftY="0.2">
    <div class="close">
      <img class="hover_btn" src="../../assets/icons/close.svg" @click="close()"  alt="">
    </div>
    <div class="modal-form">
      <div class="input-block">
        <h4>Договор</h4>
        <table>
          <tr>
            <th>Мое юр лицо</th>
            <th>Юр лицо партнера</th>
            <th>Договор</th>
            <th>Выбрать</th>
          </tr>
          <tr v-for="contract in contracts" :key="contract.id">
            <td v-if="type == 1">
              {{contract.entity_provider != null ? contract.entity_provider.company_name : ''}}
            </td>
            <td v-if="type == 2">
              {{contract.entity != null ? contract.entity.company_name : ''}}
            </td>
            <td v-if="type == 2">
              {{contract.entity_provider != null ? contract.entity_provider.company_name : ''}}
            </td>
            <td v-if="type == 1">
              {{contract.entity != null ? contract.entity.company_name : ''}}
            </td>
            <td>{{contract.number}}</td>
            <td>
              <app-radio
                      v-model="select_contract"
                      :val="contract.id"
              />
            </td>
          </tr>
        </table>
        <div style="font-size: 12px; margin-top: 10px;" v-if="delivery_company && delivery_type">Транспортная компания: {{delivery_company}} ({{delivery_type}})</div>
        <span class="text-danger text-sm" v-if="select_error">{{ select_error }}</span>
      </div>
      <h4 v-if="counteragents.length > 0 && select_delivery_company == 'Деловые линии'">Контрагенты деловых линий</h4>
      <table v-if="counteragents.length > 0">
        <tr>
          <th>Контрагент деловых линий</th>
          <th>Выбрать</th>
        </tr>
        <tr v-for="counteragent in counteragents" :key="counteragent.id">
          <td>{{counteragent.name}}</td>
          <td>
            <app-radio
                v-model="select_counteragent"
                :val="counteragent.uid"
            />
          </td>
        </tr>
      </table>
      <div class="btn">
        <button style="margin-top: 16px;" v-if="type == 1" @click="save()">Отправить в 1С</button>
        <button style="margin-top: 16px;" v-if="type == 2" @click="send()">Отправить</button>
      </div>
    </div>
  </modal>
</template>

<script>

import AppRadio from "@/components/app-radio";

export default {
  name: "provider-entity-modal",
  components: {AppRadio },
  data: ()=> ({
    contracts: [],
    select_contract: '',
    id: '',
    type: '',
    provider: '',
    purchaser: '',
    select_error: '',
    delivery_company: '',
    delivery_type: '',
    receiver_info: [],
    counteragents: [],
    select_counteragent: '',
    select_delivery_company: ''
  }),
  methods: {
    open(order, company, type, receiver_info = null, delline_session = null, select_delivery_company = null){
      if (order) {
        this.counteragents = [];
        this.id = order.id;
        this.provider = order.provider_id;
        this.purchaser = order.purchaser_id;
        this.type = localStorage.getItem('type');
        this.receiver_info = receiver_info;

        if (order.contract_id) {
          this.select_contract = order.contract_id;
        }

        this.delivery_company = '';
        this.delivery_type = '';
        if(company) {
          this.delivery_company = company;
        }

        if(type) {
          this.delivery_type = type;
        }

        this.select_delivery_company = select_delivery_company;

        if (receiver_info && select_delivery_company && select_delivery_company == 'Деловые линии') {
          if ((receiver_info.delline_login && receiver_info.delline_password) || delline_session) {
            this.getCounteragents();
          }
        }

        this.getContracts();

        this.$modal.show('entity-modal');
      }
    },
    clear(){
      this.id = '';
    },
    close() {
      this.$emit('clear', '');
      this.$modal.hide('entity-modal');
    },
    send() {
      this.select_error = '';
      if (!this.select_contract) {
        this.select_error = 'Выберите договор';
      }

      if (!this.select_error) {
        this.$emit('select_contract', this.select_contract);
        this.$emit('select_counteragent', this.select_counteragent);
        this.$emit('send');
        this.$modal.hide('entity-modal');
      }
    },
    getCounteragents() {
      if (localStorage.getItem('token')) {
        this.$http.post('/get-delline-counteragents', {
          token: localStorage.getItem('token'),
          receiver_info: this.receiver_info
        }).then(({data}) => {
          if (data.counteragents.length > 0) {
            this.counteragents = data.counteragents
            this.select_counteragent = data.counteragents[0].uid
          }
        })
            .catch((error) => {
              console.log(error)
            })
      }
    },
    getContracts() {
      if (localStorage.getItem('token')) {
        this.$http.post('/get-active-contracts', {
          token: localStorage.getItem('token'),
          provider_id: this.provider,
          purchaser_id: this.purchaser
        }).then(({data}) => {
          if (data.contracts) {
            this.contracts = data.contracts
          }
        })
        .catch((error) => {
            console.log(error)
        })
      }
    },
    save(){
      this.$validator.validateAll()
          .then(success => {
            if(success){
              if (localStorage.getItem('token')) {
                this.$http.post('/order-xml', {
                  token: localStorage.getItem('token'),
                  id: this.id,
                  contract: this.select_contract
                }).then(({data}) => {
                  if (data.success) {
                    this.$toast.success('Заказ отправлен в 1С');
                    this.$emit('saved');
                    this.$modal.hide('entity-modal');
                    this.clear();
                  }
                })
                .catch((error) => {
                    console.log(error)
                })
              }
            }
          })
    }
  }
}
</script>

<style scoped lang="scss">

.progress-bar-container {
  width: 140px;
  margin: 0px auto;
}

.btn{
  width: 100%;
  padding: 0;
  button{
    width: 100%;
    height: 50px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    background: #2CB181;
    border-radius: 4px;
    border: none;
  }
}
.modal-form {
  padding: 30px;
}
.input-block {
  margin-bottom: 15px;
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;
  &.add{
    display: flex;
    justify-content: space-between;
    a{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      text-decoration-line: underline;
      color: #7A818F;
    }
  }
}
input{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}
</style>
